import { useEffect } from 'react'
import { GOALS, reachGoal } from '../lib/metrika'

/**
 * Отправляет цель «секция просмотрена» — по одному разу на каждую секцию
 * с id. Это даёт воронку скролла: видно, до какого экрана люди доходят
 * и где отваливаются.
 *
 * Одним наблюдателем на все секции сразу, а не вызовом внутри каждой:
 * секции ничего не знают про аналитику, и добавление новой не требует
 * править её код.
 */
export function useSectionViews() {
  useEffect(() => {
    const sections = document.querySelectorAll<HTMLElement>('section[id]')
    if (!sections.length) return

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue
          // Половина секции в экране — просмотр. Но секции выше экрана (например
          // «Как работает» с телефонами) до половины не доходят никогда, поэтому
          // им хватает того, что они заняли больше половины экрана.
          const seen =
            entry.intersectionRatio >= 0.5 ||
            entry.intersectionRect.height >= window.innerHeight * 0.5
          if (!seen) continue
          reachGoal(GOALS.sectionView, { section: entry.target.id })
          // Цель нужна разово: дальше секция только шумела бы при скролле туда-сюда.
          observer.unobserve(entry.target)
        }
      },
      { threshold: [0.1, 0.25, 0.5] },
    )

    sections.forEach((section) => observer.observe(section))
    return () => observer.disconnect()
  }, [])
}
